import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HoldingsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: "3px 3px 10px 0 rgba(0,0,0,0.10)",
      background: "pink",
      borderRadius: "12px",
      padding: "25px 25px",
    },
    title: {
      fontSize: "19px",
      fontWeight: 600,
      [theme.breakpoints.up("md")]: {
        fontSize: "19px",
      },
    },
    subTitle: {
      fontSize: "16.8px",
      fontWeight: theme.typography.fontWeightRegular,
      alignSelf: "center",
      textAlign: "end",
    },
    gains: {
      color: "#01C0AA",
      fontSize: "16px",
    },
    loses: {
      color: "#EA0C01",
      fontSize: "16px",
    },
    box: {
      boxShadow: "0px 6px 12px rgba(100, 100, 111, 0.2)",
      borderRadius: "20px",
      padding: "12px 20px",
    },
  }),
);
